import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

// Import Components and Styles
import styles from './speech_bubble.css';

/**
 * Speech Bubble Component
 * @param {Object} props React props
 * @returns {SpeechBubble} a SpeechBubble component
 */
const SpeechBubble = (props) => {
    const { variant, children, className } = props;
    return <div className={classNames(className, styles.root, styles[`variant_${variant}`])}>{children}</div>;
};

SpeechBubble.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string,
    children: PropTypes.node.isRequired
};

export { SpeechBubble };
